import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { useRef } from 'react';

import FlatLayout from 'components/Layout/FlatLayout';
import HighlightedStores from 'components/Sidebar/HighlightedStores/V2';

import StoreDetails from './StoreDetails';

const StoreChecklist = dynamic(() => import('./StoreChecklist'));
const CleverCoreAd = dynamic(() => import('components/CleverCoreAd'), {
  ssr: false,
});

const StoreSidebar = ({
  gaEventCategory,
  hasPhysicalStore,
  isCnpjValid,
  isStoreChecklistActive = true,
  isVerified,
  popularStores,
  storeAddress,
  storeContacts,
  storeDescription,
  storeDomain,
  storeDomainEnriched,
  storeFacebookPage,
  storeName,
  storeRating,
  storeRatingCount,
  storeSlug,
}) => {
  const storeDetailsRef = useRef(null);
  const storeChecklistRef = useRef(null);
  const highlightedStoresRef = useRef(null);

  return (
    <FlatLayout.Sidebar
      refsToBeIgnoredBeforeFixing={[
        storeDetailsRef,
        storeChecklistRef,
        highlightedStoresRef,
      ]}
    >
      <StoreDetails
        ref={storeDetailsRef}
        gaEventCategory={gaEventCategory}
        storeAddress={storeAddress}
        storeContacts={storeContacts}
        storeDescription={storeDescription}
        storeDomain={storeDomain}
        storeDomainEnriched={storeDomainEnriched}
        storeFacebookPage={storeFacebookPage}
        storeName={storeName}
        storeRating={storeRating}
        storeRatingCount={storeRatingCount}
        storeSlug={storeSlug}
      />
      {isStoreChecklistActive && (
        <StoreChecklist
          ref={storeChecklistRef}
          hasPhysicalStore={hasPhysicalStore}
          isCnpjValid={isCnpjValid}
          isVerified={isVerified}
          storeName={storeName}
        />
      )}
      <HighlightedStores ref={highlightedStoresRef} stores={popularStores} />
      <CleverCoreAd />
    </FlatLayout.Sidebar>
  );
};

StoreSidebar.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  hasPhysicalStore: PropTypes.bool.isRequired,
  isCnpjValid: PropTypes.bool.isRequired,
  isStoreChecklistActive: PropTypes.bool,
  isVerified: PropTypes.bool.isRequired,
  popularStores: PropTypes.arrayOf(
    PropTypes.shape({
      storeName: PropTypes.string,
      storeSlug: PropTypes.string,
    })
  ),
  storeAddress: PropTypes.string,
  storeContacts: PropTypes.string,
  storeDescription: PropTypes.string,
  storeDomain: PropTypes.string.isRequired,
  storeDomainEnriched: PropTypes.string,
  storeFacebookPage: PropTypes.string,
  storeName: PropTypes.string.isRequired,
  storeRating: PropTypes.number,
  storeRatingCount: PropTypes.number,
  storeSlug: PropTypes.string.isRequired,
};

export default StoreSidebar;
